import { Component } from '@angular/core';
import { AlertController, App } from 'ionic-angular';
import { LotteryService } from "../../services/lottery.services";
import { AppConfigService } from "../../services/appConfig.service";
import { RecordListPage } from "../recordList/recordList";

// @IonicPage({
//     name: 'detail', // Đặt tên cho trang trong điều hướng
//     segment: 'detail/:id' // Cấu hình URL với tham số
//   })

@Component({
    templateUrl: 'lotteryRecord.html',
    selector: 'lottery-record-page',
})
export class LotteryRecordPage {
    recordList: any = [];
    configVipItems: any;
    // arrMMCGameID = [100, 101, 102, 103, 104, 80 , 91, 93];
    arrMMCGameID = [100, 101, 102, 103, 104, 80, 91, 93, 300, 301, 302, 303, 304, 305, 400, 401, 402];
    constructor(private app: App, private alertCtrl: AlertController,
        private lotteryService: LotteryService) {
    }

    goDetail(lotteryId: number, lotteryName: string) {
        this.app.getRootNav().push(RecordListPage, {
            lotteryName: lotteryName,
            lotteryId: lotteryId
        });
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    /**
     * convert win number of sm to array
     */
    smWinNumberToArray(data) {
        let numbers = [];
        // winnumber exp: "12|43|21|9|2|10&7"
        // special number -> 7
        // numbers array 1->6 => 12, 43, 21, 9, 2, 10
        let types = data.split('&');

        if (types.length === 2) {
            let specialNumber = Number.parseInt(types[1]);
            let normalNumbers = types[0].split('|');

            numbers.push(specialNumber);
            normalNumbers.forEach(number => {
                numbers.push(Number.parseInt(number));
            });
        }
        return numbers;
    }

    getFirstData(refresher: any = null) {
        let dataParams = {};
        this.lotteryService.lotteryAllWinOpenNumber(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.recordList = data["openlist"];
                this.recordList.map(item => {
                    item["flagMMCGame"] = false;
                    if (this.arrMMCGameID.indexOf(item["lotteryid"]) > -1) {
                        item["flagMMCGame"] = true;
                    }
                    // in case lottery is sixmark
                    if (item["lotteryid"] === 81 || item["lotteryid"] === 82) {
                        item["winnumber"] = this.smWinNumberToArray(item["winnumber"]);
                    } else {
                        item["winnumber"] = item["winnumber"].split(',');
                    }
                    return item;
                });
                if (refresher) {
                    refresher.complete()
                }
            }
        });
    }

    ionViewWillEnter() {
        this.getFirstData();
        try {
            this.configVipItems = JSON.parse(localStorage.getItem('configVipItems'));
            // console.log('====================================');
            // console.log('this.configVipItems', this.configVipItems);
            // console.log('====================================');
        } catch (error) {
                console.log('====================================');
                console.log(error);
                console.log('====================================');
        }
        
    }

}



// WEBPACK FOOTER //
// ./src/pages/lotteryRecord/lotteryRecord.ts